import React from 'react';
import DossierLoadingScreen from '../components/DossierLoadingScreen';

// Demo page to preview the splash loader in isolation (admin testing)
const SplashDemoPage = () => <DossierLoadingScreen title="L'Équipage Odys" />;

export default SplashDemoPage;
